import {CanonicalizeUnicodeLocaleId} from '#packages/intl-localematcher/abstract/CanonicalizeUnicodeLocaleId.js'
import type {Keyword} from '#packages/intl-localematcher/abstract/types.js'
import {
  invariant,
  splitUnicodeExtension,
} from '#packages/intl-localematcher/abstract/utils.js'

export function InsertUnicodeExtensionAndCanonicalize(
  locale: string,
  attributes: string[],
  keywords: Array<Keyword>
): string {
  invariant(
    splitUnicodeExtension(locale).extension === undefined,
    'Expected locale to not have a Unicode locale extension'
  )
  let extension = '-u'
  for (const attr of attributes) {
    extension += `-${attr}`
  }
  for (const kw of keywords) {
    const {key, value} = kw
    extension += `-${key}`
    if (value !== '') {
      extension += `-${value}`
    }
  }
  if (extension === '-u') {
    return CanonicalizeUnicodeLocaleId(locale)
  }
  let privateIndex = locale.indexOf('-x-')
  let newLocale
  if (privateIndex === -1) {
    newLocale = locale + extension
  } else {
    let preExtension = locale.slice(0, privateIndex)
    let postExtension = locale.slice(privateIndex)
    newLocale = preExtension + extension + postExtension
  }
  return CanonicalizeUnicodeLocaleId(newLocale)
}
